import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue';
import { Input } from 'ant-design-vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchChat',
  emits: ["onSearch"],
  setup(__props, { emit }: { emit: ({
    (e: 'onSearch', value: string): void;
}), expose: any, slots: any, attrs: any }) {



const input = ref('');

function onSearch() {
    emit('onSearch', input.value);
}

watch(input, (newValue: string | null, oldValue: string | null) => {
    if (newValue === '' && oldValue !== '') {
        onSearch();
    }
});

return { __sfc: true,emit, input, onSearch, Input }
}

})